import L from 'leaflet';
import { useMap } from 'react-leaflet';

export const ISPLegend = ({ Program }) => {
    const elementExists = document.getElementById("legend_id_isp");
    if (elementExists) {
        elementExists.remove();
    }

    const map = useMap();

    const legend = L.control({ position: 'topright' });

    legend.onAdd = function () {
        const div = L.DomUtil.create('div', 'legend_choropleth');
        div.setAttribute('id', 'legend_id_isp');

        // Legend title
        const legend_title = document.createElement('div');
        legend_title.setAttribute('id', 'choropleth_legend_title');
        legend_title.innerText = `${Program} ISP Coverage`;
        div.appendChild(legend_title);

        // Container for legend items
        const legend_items = document.createElement('div');
        legend_items.setAttribute('class', 'legend-items');

        // Define your ISP colors
        const ispColors = [
            { label: "TNM", color: "red" },
            { label: "AIRTEL", color: "blue" },
            { label: "STARLINK", color: "green" },
            { label: "FIBRE", color: "brown" },
            { label: "MOH WAN", color: "black" },
            { label: "Multiple ISPs", color: "purple" },
            { label: "Unknown / Null", color: "yellow" }
        ];

        // Create legend items
        ispColors.forEach(item => {
            const legend_item = document.createElement('div');
            legend_item.setAttribute('class', 'legend-item');
            legend_item.style.marginTop = '5px';

            const color_box = document.createElement('div');
            color_box.setAttribute('class', 'legend-color');
            color_box.style.backgroundColor = item.color;
            color_box.style.width = '20px';
            color_box.style.height = '20px';
            color_box.style.borderRadius = item.label === "Multiple ISPs" || item.label === "Unknown / Null" ? '50%' : '0';
            color_box.style.display = 'inline-block';

            const label_span = document.createElement('span');
            label_span.innerText = item.label;
            label_span.style.marginLeft = '10px';

            legend_item.appendChild(color_box);
            legend_item.appendChild(label_span);

            legend_items.appendChild(legend_item);
        });

        div.appendChild(legend_items);
        return div;
    };

    map.addControl(legend);

    return null;
};
